import { Col, Row } from 'antd'
import Grid from 'antd/lib/card/Grid'
import React, { PropsWithChildren } from 'react'
import { LoginForm, LoginRequest } from './Form/LoginForm'
import { LoginInfoView } from './LoginInfoView'




export function LoginPageContent({ children }: PropsWithChildren<{}>) {

  const style: React.CSSProperties = { padding: '20px' };

  return (
    <div className='login-root'>
        <div className='loginPage fade-in-login'>
          <div className='MuiGrid-container loginContainer loginMainCard'>
            <LoginForm
              onSubmit={() => { }} />
            <LoginInfoView />
          </div>
        </div>
      </div>
  )
}

function LoginPage() {
  return (
    <LoginPageContent>

      {/* <LoginForm onSubmit={(value) => console.log(value)} /> */}


    </LoginPageContent>
  )
}

export default LoginPage
